module.exports = __webpack_public_path__ + "img/BRX.076313b2.svg";